import { render, staticRenderFns } from "./skjh.vue?vue&type=template&id=3856f927&scoped=true"
import script from "./skjh.vue?vue&type=script&lang=js"
export * from "./skjh.vue?vue&type=script&lang=js"
import style0 from "./skjh.vue?vue&type=style&index=0&id=3856f927&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856f927",
  null
  
)

export default component.exports